import { render, staticRenderFns } from "./contactIndex.vue?vue&type=template&id=13424ae1&scoped=true"
import script from "./contactIndex.vue?vue&type=script&lang=js"
export * from "./contactIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13424ae1",
  null
  
)

export default component.exports